import $ from 'jquery';
import constants from 'Constants.js';
import { View } from 'backbone';
import {Model} from 'backbone';
import listService      from 'ListService.js';
import sequenceService from 'SequenceService.js';
import SelectFieldModal from 'common-views/SelectFieldModalView.js';
import FormulaModal from 'common-views/MainFormulaModalView';
import BaseTableView from 'properties/BaseTableView.js'
import Template from 'behaviors/properties/main/parameters.ejs';
//=====================================================================
//
// An instance of this view represents a Parameters.
//
// Casey Justus, April 25, 2016
//
//=====================================================================

class MainParametersView extends BaseTableView {

    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.defaultGridSize = 3;

        this.events = {
            "click .itemNew"              : "itemNew",
            "click .itemRemove"           : "itemRemove"
        };

        this.model.set({
            gridData : [
                {'name':'', 'source':'', 'formula': ''},
                {'name':'', 'source':'', 'formula': ''},
                {'name':'', 'source':'', 'formula': ''}
            ],
            colModel: [
                {
                    name: 'name',
                    index: 'name',
                    editable: true,
                    hidden: true
                },
                {
                    name: 'source',
                    index: 'source',
                    //width: 100,
                    editable: false
                },
                {
                    name: 'formula',
                    index: 'formula',
                    width: 75,
                    edittype: 'checkbox',
                    editoptions: { value:"selected" },
                    formatter: "checkbox",
                    formatoptions: { disabled: false}
                }

            ],
            colNames: ['Name', 'Source', 'Formula']
        }, {silent: true});

        this.loadDataFromCustomParameters();

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    loadDataFromCustomParameters() {
        this.model.set('gridData', [], {silent: true});
        const parameters = this.model.attributes.CustomParameters.parameter;

        let gridData = this.model.get('gridData');
        let objName = '';

        for (let param of parameters) {
            objName = '';
            if (param._value) {
                const id = param._value;
                const obj = listService.getObject(listService.cleanId(id));
                if (obj) {
                    objName = obj ? obj.model.get('name') : '';
                }
            }

            let newRow = {
                'name': param._name,
                'source': param._type === 'expression' ? '[Formula]' : objName,
                'formula': param._type === 'expression' ? 'selected' : ''
            };
            gridData.push(newRow);
        }
        this.model.set('gridData', gridData, {silent: true});
    }

    itemNew(){
        var gridData = this.model.get('gridData');
        let index = 1;
        if (gridData.length > 0) {
            index = this.lastIndexOnGrid() + 1;
        }

        let newRow = {
            'name':'Parameter ' + (gridData.length+1) ,
            'source':'',
            'formula': ''
        };

        let emptyRow = this.nextEmptyRow();
        if ( emptyRow >= 0 ){
            // Fill empty row
            $(constants.PROP_MAIN_TABLE).setRowData(emptyRow, newRow);
            gridData[emptyRow] = newRow;
        } else {
            //  Add new data
            $(constants.PROP_MAIN_TABLE).addRowData((index), newRow);
            gridData.push(newRow);
        }

        this.model.attributes.CustomParameters.parameter.push({_id: sequenceService.nextDomId() , _name: newRow.name, _type: 'field', _value: ''});

        this.model.set('gridData', gridData);
    }

    itemRemove(){
        const rowid = this.model.get('rowid');
        this.model.attributes.CustomParameters.parameter.splice(rowid,1);

        super.itemRemove();
    }

    onCellSelect(rowId, iCol, cellcontent, e) {

        const colNames = this.model.get('colNames');
        if (colNames[iCol] !== 'Source' ) {
            return;
        }

        let rowIdModel=parseInt(rowId);
        let gridData = this.model.get('gridData');
        console.log('Current Grid Data',gridData);
        console.log('Current Grid Data Row',gridData[rowIdModel]);
        if (gridData[rowIdModel].formula === 'selected') {
            console.log('Formula Modal Opened');
            let attributes = {formulaParameter: this.model.attributes.CustomParameters.parameter[rowIdModel].Expression };

            let sfModal = new FormulaModal({model: new Model(attributes),config:{viewTitle: "Formula"}});
            sfModal.render().then((formulaParameter)=> {
                this.model.attributes.CustomParameters.parameter[rowIdModel].Expression = formulaParameter;
            });
        }
        else {
            console.log('Select Field Modal Opened');
            let sfModal = new SelectFieldModal({model: this.model,config:{viewTitle: "Select Field"}});
            sfModal.render().then((selectedField)=> {
                gridData[rowIdModel].source = selectedField.name;
                this.model.set('gridData', gridData,{silent:true});
                this.model.attributes.CustomParameters.parameter[rowIdModel]._value = selectedField.id;
                this.render();
            });
        }
    }

    nextEmptyRow() {
        let rowIndex = -1;
        let dataGrid = $(constants.PROP_MAIN_TABLE).jqGrid('getGridParam', 'data');
        let index = 0;
        while (rowIndex < 0 && index < dataGrid.length && dataGrid.length <= this.defaultGridSize ) {
            let row = dataGrid[index];
            if (this.isEmpty(row)) {
                rowIndex = row.id;
            }
            ++index;
        }
        return rowIndex;
    }

    isEmpty(row){
        let res = false;
        if (!row.source && !row.formula) {
            res = true;
        }
        return res;
    }

    lastIndexOnGrid() {
        let gridData = $(constants.PROP_MAIN_TABLE).jqGrid('getGridParam', 'data');
        let index = gridData[gridData.length-1].id;
        return parseInt(index)
    }



}

export default MainParametersView;
